


















import Vue from "vue";
import AdminService from "@/services/adminService";
import SharedFilesService from "@/services/sharedFilesService";

export default Vue.extend({
  name: "CreateFolder",

  data() {
    return {
      folder_name: "",
      creating: false
    };
  },
  methods: {
    async submit(e) {
      this.creating = true;
      e.preventDefault(); // Prevent page from reloading.
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const sharedFilesService = new SharedFilesService(jwt);
          const formData = new FormData();
          formData.append("folder_name", this.folder_name.trim());
          const response = await sharedFilesService.createFolders(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.creating = false;
              alert("Create Successfully");
              await this.$router.push("/sharedfiles");
            }
          }
        } catch (error) {
          this.creating = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/sharedfiles");
    }
  }
});
